<template>
    <div class="survey-type-container">
        <div class="card-container">
            <div class="section-desc">
                该表格统计层次为“本科”和“预科”的学生数。
            </div>
            
            <el-form inline :model="form">
                <el-form-item>
                    <el-button type="primary" @click="loadData" :loading="loading">查询</el-button>
                    <el-button type="success" @click="handleExport">导出</el-button>
                </el-form-item>
            </el-form>

            <div class="data-table-wrapper">
                    <div class="data-table-body">
                        <h3 class="table-title">近一级本科生招生类别情况（时点）（表 6-3-1）</h3>
                        <el-table :data="tableData" border style="margin-top: 20px;" :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '600'}">
                            <el-table-column prop="jhrs" label="招生计划数" min-width="120" align="center"></el-table-column>
                            <el-table-column prop="lqrs" label="实际录取数" min-width="120" align="center"></el-table-column>
                            <el-table-column prop="bdrs" label="实际报到数" min-width="120" align="center"></el-table-column>
                            <el-table-column prop="tslx" label="特殊类型招生数" min-width="150" align="center"></el-table-column>
                            <el-table-column prop="qjjh" label="其中：强基计划招生数" min-width="180" align="center"></el-table-column>
                            <el-table-column prop="gxxm" label="其中：高校专项计划招生数" min-width="200" align="center"></el-table-column>
                            <el-table-column prop="bss" label="其中：保送生招生数" min-width="180" align="center"></el-table-column>
                            <el-table-column prop="gspysdt" label="其中：高水平艺术团招生数" min-width="210" align="center"></el-table-column>
                            <el-table-column prop="gspydd" label="其中：高水平运动队招生数" min-width="210" align="center"></el-table-column>
                            <el-table-column prop="ysl" label="其中：艺术类招生数" min-width="180" align="center"></el-table-column>
                            <el-table-column prop="gat" label="其中：港澳台招生数" min-width="180" align="center"></el-table-column>
                            <el-table-column prop="zwhzb" label="其中：中外合作办学招生数" min-width="210" align="center"></el-table-column>
                            <el-table-column prop="ssmz" label="其中：少数民族预科班招生数" min-width="230" align="center"></el-table-column>
                            <el-table-column prop="zhpj" label="其中：综合评价招生数" min-width="200" align="center"></el-table-column>
                            <el-table-column prop="bsxs" label="招收本省学生数" min-width="150" align="center"></el-table-column>
                        </el-table>
                    </div>
                </div>
        </div>
    </div>
</template>

<script>
import { TYBM_Env } from '../../env.js';
import { TYBM_Tools } from '../../tools.js';

export default {
    name: 'SurveyType',
    inject: ['getCurrentYear'],
    data() {
        return {
            form: {},
            tableData: [],
            loading: false,
            year: 0
        };
    },
    methods: {
        loadData() {
            const that = this;
            that.loading = true;
            const api_name = '/Survey/GetSurveyTypeData';
            const url = TYBM_Env.GetApiUrl(api_name);

            TYBM_Tools.AxiosGetEx(that, api_name, url, { loading_msg: '正在加载数据' })
                .then(result => {
                    that.tableData = result.data.List;
                    that.year = result.data.Year;
                })
                .catch(() => {
                    that.$message.error('加载数据失败');
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        handleExport() {
            const that = this;
            if (that.tableData.length === 0) {
                that.$message.warning('没有数据可导出');
                return;
            }

            let csvContent = "\uFEFF";
            const headers = ["招生计划数", "实际录取数", "实际报到数", "特殊类型招生数", "其中：强基计划招生数", 
                           "其中：高校专项计划招生数", "其中：保送生招生数", "其中：高水平艺术团招生数", 
                           "其中：高水平运动队招生数", "其中：艺术类招生数", "其中：港澳台招生数", 
                           "其中：中外合作办学招生数", "其中：少数民族预科班招生数", "其中：综合评价招生数", 
                           "招收本省学生数"];
            csvContent += headers.join(",") + "\n";

            that.tableData.forEach(row => {
                const rowData = [
                    row.jhrs, row.lqrs, row.bdrs, row.tslx, row.qjjh, row.gxxm, row.bss,
                    row.gspysdt, row.gspydd, row.ysl, row.gat, row.zwhzb, row.ssmz, row.zhpj, row.bsxs
                ];
                csvContent += rowData.join(",") + "\n";
            });

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", `招生类别情况_${that.year}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        onYearChange() {
            this.loadData();
        }
    },
    created() {
        this.$root.$on('global-year-change', this.onYearChange);
    },
    beforeDestroy() {
        this.$root.$off('global-year-change', this.onYearChange);
    },
    mounted() {
        this.loadData();
    }
};
</script>

<style scoped>
.survey-type-container {
    width: 100%;
}

.section-desc {
    margin-bottom: 20px;
    padding: 10px;
    background-color: #fdf6ec;
    color: #e6a23c;
    border-radius: 4px;
    font-size: 14px;
}

.table-title {
    text-align: center;
    margin-bottom: 15px;
    font-size: 16px;
    color: #303133;
}

.data-table-wrapper {
    background: white;
    border-radius: 8px;
    overflow-x: auto;
    overflow-y: auto;
    max-height: calc(100vh - 520px);
    padding: 10px;
}

.data-table-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.data-table-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 5px;
}

.data-table-wrapper::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 5px;
}

.data-table-wrapper::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.data-table-body {
    width: max-content;
    min-width: 100%;
}

.data-table-body >>> .el-table {
    font-size: 13px;
}

.data-table-body >>> .el-table th,
.data-table-body >>> .el-table td {
    padding: 8px 0 !important;
}

.data-table-body >>> .el-table th {
    background-color: #f5f7fa !important;
    color: #606266;
    font-weight: 600;
}

.data-table-body >>> .el-table__row:hover {
    background-color: #f5f9ff;
}
</style>

